import {
  FieldTypes,
  referenceTextField,
  textNumberField,
  currentSubTenantObj,
  currentTenantObj,
  currentSettingObj,
  currentUserObj,
  CURRENT_SUB_TENANT,
  CURRENT_SETTINGS,
  CURRENT_TENANT,
  CURRENT_USER,
  CURRENTS,
} from 'drapcode-constant';
import { checkAndCompareValue, checkAndExtractValue } from '../../../../common/utils/rest_utils';
import {
  EQUALS,
  IS_NOT_NULL,
  IS_NULL,
  LIKE,
  IN_LIST,
  NOT_IN_LIST,
  LESS_THAN,
  GREATER_THAN,
  LESS_THAN_EQUALS_TO,
  GREATER_THAN_EQUALS_TO,
  BETWEEN,
  NOT_EQUAL,
  excludedFieldTypeSort,
  excludedFieldNameSort,
  excludedFieldType,
  excludedFieldName,
  referenceTypeArray,
  DateTimeUnit,
  CURRENT_TIME,
  CURRENT_DATE,
  CURRENT_DATE_TIME,
  CURRENT_MONTH,
  CURRENT_YEAR,
  EQUALS_OR_IGNORE,
  CURRENT_WEEK,
} from './query-constant';
import {
  moveDefaultCollectionFieldsToEndAndSort,
  snakeCaseToTitleCase,
} from '../../../../common/utils/api_utils';
import { extractRefField } from '../../../../common/utils/field-options';
import * as Yup from 'yup';
import { defaultFields2 } from '../../../../common/utils/constant';

const { createdBy, uuid, text, number, color, date } = FieldTypes;

export const findTypeOfField = (fields, selectedField) => {
  const field = fields.find((field) => field.fieldName === selectedField);
  //TODO: need to remove this toLowerCase() and make required changes
  return field ? field.type.toLowerCase() : '';
};

export const supportedConditions = (fields, selectedField) => {
  const fieldType = findTypeOfField(fields, selectedField);
  if (!fieldType) {
    return [];
  }

  switch (fieldType) {
    case 'uuid':
      return [EQUALS, NOT_EQUAL, EQUALS_OR_IGNORE, IN_LIST, NOT_IN_LIST];
    case 'text':
    case 'large_text':
      return [
        EQUALS,
        NOT_EQUAL,
        EQUALS_OR_IGNORE,
        IS_NOT_NULL,
        IS_NULL,
        LIKE,
        IN_LIST,
        NOT_IN_LIST,
      ];
    case 'createdBy':
    case 'createdby':
    case 'boolean':
      return [EQUALS, NOT_EQUAL, EQUALS_OR_IGNORE, IS_NOT_NULL, IS_NULL];
    case 'date':
    case 'createdat':
    case 'updatedat':
    case 'createdAt':
    case 'updatedAt':
    case 'time_slot':
      return [
        IS_NULL,
        IS_NOT_NULL,
        EQUALS,
        EQUALS_OR_IGNORE,
        NOT_EQUAL,
        LESS_THAN,
        GREATER_THAN,
        LESS_THAN_EQUALS_TO,
        GREATER_THAN_EQUALS_TO,
        BETWEEN,
      ];
    case 'number':
      return [
        EQUALS,
        EQUALS_OR_IGNORE,
        IS_NOT_NULL,
        IS_NULL,
        IN_LIST,
        NOT_IN_LIST,
        LESS_THAN,
        GREATER_THAN,
        LESS_THAN_EQUALS_TO,
        GREATER_THAN_EQUALS_TO,
        BETWEEN,
        NOT_EQUAL,
      ];
    case 'color':
      return [EQUALS, NOT_EQUAL, EQUALS_OR_IGNORE, IS_NOT_NULL, IS_NULL, IN_LIST, NOT_IN_LIST];
    case 'belongsto':
      return [EQUALS, EQUALS_OR_IGNORE, IS_NOT_NULL, IS_NULL, IN_LIST, NOT_IN_LIST];
    case 'static_option':
    case 'dynamic_option':
    case 'reference':
      return [IS_NOT_NULL, IS_NULL, IN_LIST, NOT_IN_LIST, EQUALS_OR_IGNORE];
    case 'password':
    case 'file':
    case 'image':
    case 'multi_image':
    case 'video_link':
      return [IS_NULL, IS_NOT_NULL];
    default:
      return [IS_NULL, IS_NOT_NULL];
  }
};

export const supportedValues = (
  constants,
  fields,
  selectedField,
  selectedCondition,
  multiTenantCollection,
  userSettingsCollection,
  subTenantCollection,
) => {
  const fieldType = findTypeOfField(fields, selectedField);
  if (!fieldType) {
    return [];
  }

  let availableValues = [];
  if ([IS_NOT_NULL, IS_NULL].includes(selectedCondition.value)) {
    return [];
  }

  if (['uuid', 'text', 'color'].includes(fieldType)) {
    prepareConstantOptions(constants, 'STRING', availableValues);
    availableValues.push(currentUserObj);
    if (multiTenantCollection) availableValues.push(currentTenantObj);
    if (userSettingsCollection) availableValues.push(currentSettingObj);
    if (subTenantCollection) availableValues.push(currentSubTenantObj);
    availableValues.push({ name: 'Collection (Browser Storage)', value: 'ENTITY' });
  } else if (fieldType === 'large_text') {
    prepareConstantOptions(constants, 'STRING', availableValues);
  } else if (defaultFields2.includes(fieldType)) {
    const dateDisplayType = getDateDisplayType(fields, selectedField);
    let dateConstant = [CURRENT_TIME];
    if (dateDisplayType === 'date') dateConstant.push(CURRENT_DATE);
    if (dateDisplayType === 'datetime-local' || fieldType === 'time_slot')
      dateConstant.push(CURRENT_DATE_TIME);
    if ([EQUALS, NOT_EQUAL, EQUALS_OR_IGNORE].includes(selectedCondition.value))
      dateConstant = [...dateConstant, CURRENT_MONTH, CURRENT_YEAR, CURRENT_WEEK];
    constants
      .filter((cnst) => cnst.constantType === 'DATE')
      .map((e) => {
        availableValues.push({ name: e.name, value: e.name });
      });
    [...dateConstant, ...DateTimeUnit].forEach((cnst) => {
      availableValues.push({ name: snakeCaseToTitleCase(cnst), value: cnst });
    });
  } else if (fieldType === 'number') {
    prepareConstantOptions(constants, 'NUMBER', availableValues);
    availableValues.push({ name: 'Fixed Value', value: 'FIXED_VALUE' });
    availableValues.push(currentUserObj);
    if (multiTenantCollection) availableValues.push(currentTenantObj);
    if (userSettingsCollection) availableValues.push(currentSettingObj);
    if (subTenantCollection) availableValues.push(currentSubTenantObj);
    availableValues.push({ name: 'Collection (Browser Storage)', value: 'ENTITY' });
  } else if (fieldType === 'boolean') {
    prepareConstantOptions(constants, 'BOOLEAN', availableValues);
    availableValues.push({ name: 'True', value: 'true' });
    availableValues.push({ name: 'False', value: 'false' });
  } else if (['createdby', createdBy.id].includes(fieldType)) {
    availableValues.push(currentUserObj);
    if (multiTenantCollection) availableValues.push(currentTenantObj);
    if (userSettingsCollection) availableValues.push(currentSettingObj);
    if (subTenantCollection) availableValues.push(currentSubTenantObj);
    availableValues.push({ name: 'Collection (Browser Storage)', value: 'ENTITY' });
  } else if (fieldType === 'static_option') {
    const selectedFieldForOption = fields.find((field) => field.fieldName === selectedField);
    if (selectedFieldForOption) {
      availableValues = selectedFieldForOption.staticOptions.map((option) => ({
        name: option,
        value: option,
      }));
    }
  }

  if (![IN_LIST, NOT_IN_LIST].includes(selectedCondition.value)) {
    availableValues.push({ name: 'External', value: 'EXTERNAL' });
  }
  return availableValues;
};

const prepareConstantOptions = (constants, type, availableValues) => {
  constants
    .filter((cnst) => cnst.constantType === type)
    .map((e) => {
      availableValues.push({ name: e.name, value: e.name });
    });
};

export const createSelectOptionsForField = (fields) => {
  return filterFieldOption(fields, excludedFieldType, excludedFieldName);
};

export const createSelectOptionsForSortField = (fields) => {
  return filterFieldOption(fields, excludedFieldTypeSort, excludedFieldNameSort);
};

export const createSelectOptionsForReferenceField = (
  fields,
  collections,
  refFieldPrefix = 'RF::',
) => {
  const refFields = extractRefField(fields, collections);
  const refFieldsOptions = refFields.map((field) => ({
    value: `${refFieldPrefix}${field.fieldName}`,
    label: field.fieldTitle,
  }));
  return refFieldsOptions;
};

export const filterFieldOption = (fields, filterCriteria1, filterCriteria2) => {
  if (fields && fields.length > 0) {
    return moveDefaultCollectionFieldsToEndAndSort(
      fields
        .filter((field) => {
          return !filterCriteria1.includes(field.type);
        })
        .filter((field) => {
          return !filterCriteria2.includes(field.fieldName);
        }),
    ).map((field) => {
      return {
        value: field.fieldName,
        label: field.fieldTitle.en,
        type: field.type,
      };
    });
  } else {
    return [];
  }
};

export const removeQuery = (currentConditions, id) => {
  let noOfItem = 1,
    newConditions = [];
  currentConditions.forEach((condition) => {
    if (id !== condition.id) {
      condition.id = noOfItem;
      newConditions.push(condition);
      noOfItem++;
    }
  });
  return newConditions;
};

export const addQuery = (conditions) => {
  const newConditionObj = {
    id: conditions.length + 1,
    query: { field: '', key: '', value: '' },
    conjunctionType: '',
    requiredExternal: false,
    saved: false,
  };
  conditions.push(newConditionObj);
  return conditions;
};

export const updateQuery = (conditions, id, conditionObj) => {
  conditions.forEach((condition) => {
    if (condition.id === id) {
      condition.query = conditionObj.query;
      condition.conjunctionType = conditionObj.conjunctionType;
      condition.requiredExternal = conditionObj.requiredExternal;
      condition.saved = true;
    }
  });
  return conditions;
};

export const changeInFieldInclude = (name, value) => {
  let updatedValue = null;
  if (name[0] === 'selectedIncludeField') {
    const lastEntry = value ? value[value.length - 1] : null;
    if (!lastEntry || lastEntry.value === 'ALL') {
      updatedValue = [{ label: 'All', value: 'ALL' }];
    } else {
      updatedValue = value.filter((val) => val.value !== 'ALL');
    }
  } else if (name[0] === 'derivedFieldMapping') {
    updatedValue = value.value;
  } else {
    updatedValue = value;
  }
  return updatedValue;
};

const extractValue = (selectedFields) => {
  selectedFields = selectedFields.filter((field) => {
    return field.value.trim().length > 0;
  });
  return selectedFields.map((field) => {
    return field.value;
  });
};

export const compressConditions = (conditions) => {
  const newConditions = [];
  let id = 1;
  let externalParam = 0;
  conditions.forEach((condition) => {
    delete condition.saved;
    if (condition.query && condition.query.key) {
      condition.id = id;
      if (condition.requiredExternal) {
        externalParam++;
      }
      newConditions.push(condition);
      id++;
    }
  });
  return { conditions: newConditions, externalParam };
};

export const processQueryData = (values, conditionData) => {
  let {
    primaryQuery,
    selectedIncludeField,
    selectedExcludeField,
    aggregateFunctionField,
    name,
    isPrivate,
    selectOrderBy,
    selectSortField,
    enableRls,
    rlsFilter,
    addTenantQuery,
    addSubTenantQuery,
    derivedFieldMapping,
  } = values;
  const { conditions, externalParam } = conditionData;
  if (selectedIncludeField === '') {
    selectedIncludeField = 'ALL';
  }

  const queryData = {
    isPrivate,
    name,
    conditions,
    finder: primaryQuery.value,
    fieldsInclude: selectedIncludeField === 'ALL' ? '*' : extractValue(selectedIncludeField),
    fieldsExclude:
      !selectedExcludeField || selectedExcludeField === ''
        ? []
        : extractValue(selectedExcludeField),
    aggregateFunctionField: aggregateFunctionField ? aggregateFunctionField.value : '',
    noOfExternalParams: externalParam,
    sortBy: selectSortField.value,
    orderBy: selectOrderBy.value,
    enableRls,
    rlsFilter: rlsFilter.value,
    addTenantQuery,
    addSubTenantQuery,
    derivedFieldMapping: derivedFieldMapping.value,
  };

  return queryData;
};

export const generateQueryString = (
  { primaryQuery, selectedIncludeField, selectedExcludeField, conditions },
  collections,
) => {
  if (!primaryQuery) {
    return '';
  }
  let queryString = '';
  primaryQuery = primaryQuery.value;
  if (primaryQuery === 'FIND') {
    queryString += 'Find first matching data ';
  } else if (primaryQuery === 'FIND_ALL') {
    queryString += 'Find all matching data ';
  } else {
    queryString += 'Count ';
  }
  const checkAllExist = selectedIncludeField[0];
  if (checkAllExist.value === 'ALL') {
    queryString += 'all fields ';
    if (selectedExcludeField) {
      queryString += 'except ';
      selectedExcludeField.forEach((field) => {
        queryString += field.value + ',';
      });
    }
  } else {
    selectedIncludeField.forEach((field) => {
      if (field.value.startsWith('DF::')) {
        const derivedField = extractDerivedFieldFromMetaData(field.value);
        queryString += 'DF::' + derivedField.name + ',';
      } else {
        queryString += field.value + ',';
      }
    });
  }

  if (conditions.length > 0) {
    queryString += ' where ';

    conditions.forEach((condition) => {
      const { conjunctionType, query } = condition;
      if (conjunctionType) queryString += `${conjunctionType} `;
      if (query.field) queryString += `${query.field} `;
      if (query.key) queryString += `${snakeCaseToTitleCase(query.key)} `;
      if (query.isFilter) {
        if (query.value) queryString += `${findFilterName(collections, query)} `;
      } else {
        if (query.value) queryString += `${snakeCaseToTitleCase(query.value)} `;
        if (query.value === false) queryString += 'false';
      }
    });
  }

  return queryString;
};

export const showQueryString = (
  { finder, fieldsInclude, fieldsExclude, conditions },
  collections,
) => {
  if (!finder) {
    return '';
  }
  let queryString = '';

  if (finder === 'FIND') {
    queryString += 'Find first matching data ';
  } else if (finder === 'FIND_ALL') {
    queryString += 'Find all matching data ';
  } else {
    queryString += 'Count ';
  }
  const checkAllExist = fieldsInclude[0];
  if (checkAllExist === '*') {
    queryString += 'all fields ';
    if (fieldsExclude && fieldsExclude.length > 0) {
      queryString += 'except ';
      fieldsExclude.forEach((field) => {
        queryString += field + ',';
      });
    }
  } else {
    fieldsInclude.forEach((field) => {
      if (field.startsWith('DF::')) {
        const derivedField = extractDerivedFieldFromMetaData(field);
        queryString += 'DF::' + derivedField.name + ',';
      } else {
        queryString += field + ',';
      }
    });
  }

  if (conditions.length > 0) {
    queryString += ' where ';
    conditions.forEach((condition) => {
      const { conjunctionType, query } = condition;
      if (conjunctionType) queryString += `${conjunctionType} `;
      if (query.field) queryString += `${query.field} `;
      if (query.key) queryString += `${snakeCaseToTitleCase(query.key)} `;
      if (query.isFilter) {
        if (query.value) queryString += `${findFilterName(collections, query)} `;
      } else {
        if (query.value) queryString += `${query.value} `;
        if (query.value === false) queryString += 'false';
      }
    });
  }

  return queryString;
};

export const saveQueryUtil = (props, state) => {
  const {
    condition,
    fields,
    collections: { projectCollections },
  } = props;

  let {
    selectedField,
    selectedCondition,
    selectedValue,
    selectedValueMin,
    selectedValueMax,
    conjuctionType,
    selectedValueCollectionFieldValue,
    selectedValueCollection,
    selectedValueCollectionField,
    selectedValueCollectionFilterValue,
    choiceOfFieldSelect,
    minExternal,
    maxExternal,
    valueExternal,
    selectedCurrentUserRef,
    selectedCurrentUserRefField,
    collectionFieldValueExternal,
    isMulti,
    customEntityKey,
    entityItemPath,
    multiTenantCollection,
    userSettingsCollection,
    subTenantCollection,
    dateConstantType,
    dateUnitNum,
    minDateUnitNum,
    maxDateUnitNum,
    minDateConstantType,
    maxDateConstantType,
    valueFixedValue,
    minFixedValue,
    maxFixedValue,
  } = state;

  if (condition.id > 1 && !conjuctionType) {
    return { conjuctionTypeError: 'Please choose Conjuction', status: 'ERROR' };
  }
  if (!selectedField) {
    return { selectedFieldError: 'Please select Field', status: 'ERROR' };
  }
  if (!selectedCondition) {
    return { selectedConditionError: 'Please select Condition', status: 'ERROR' };
  }

  let confirmValue = '',
    confirmType = '',
    refCollection = '',
    refField = '';
  let isFilter = false;
  let isExternal = false;

  const fieldType = findTypeOfField(fields, selectedField.value);
  let requiredExternal = false;
  if (!['IS_NOT_NULL', 'IS_NULL'].includes(selectedCondition.value)) {
    if (referenceTypeArray.includes(fieldType)) {
      if (CURRENTS.includes(selectedValueCollection.value)) {
        confirmType = fieldType;
        if (choiceOfFieldSelect) {
          if (choiceOfFieldSelect.value === 'CHOOSE_FIELD') {
            if (selectedValueCollectionField.length === 0) {
              return {
                selectedValueError: 'Please choose current user field value',
                status: 'ERROR',
              };
            } else {
              refCollection = selectedValueCollection.value;
              refField = selectedValueCollectionField.value;
              isFilter = false;
              confirmValue = `${refCollection}::${refField}`;
            }
          } else {
          }
        } else {
          confirmValue = selectedValueCollection.value;
        }
      } else if (!choiceOfFieldSelect || choiceOfFieldSelect.value === 'CHOOSE_FIELD') {
        if (selectedValueCollectionFieldValue.length === 0) {
          return { selectedValueError: 'Please choose collection field value', status: 'ERROR' };
        } else {
          if (selectedValueCollectionFieldValue.value === 'EXTERNAL') {
            isExternal = true;
            confirmValue = collectionFieldValueExternal;
          } else if (selectedValueCollectionFieldValue.value === 'ENTITY') {
            if (!entityItemPath && !entityItemPath.value)
              return {
                entityItemPathError: 'Please define the path of entity item',
                status: 'ERROR',
              };
            confirmValue = `ENTITY::${entityItemPath.value}`;
          } else {
            confirmValue = checkAndExtractValue(selectedValueCollectionFieldValue, false);
          }
          confirmType = fieldType;
          refCollection = selectedValueCollection.value;
          refField = selectedValueCollectionField.value;
          isFilter = false;
        }
      } else {
        if (
          !selectedValueCollectionFilterValue ||
          selectedValueCollectionFilterValue.length === 0
        ) {
          return { selectedValueError: 'Please choose collection field value', status: 'ERROR' };
        } else {
          confirmValue = selectedValueCollectionFilterValue.value;
          confirmType = fieldType;
          refCollection = selectedValueCollection.value;
          refField = '';
          isFilter = true;
        }
      }
    } else if (fieldType === 'static_option') {
      if (selectedValue.value === 'EXTERNAL') {
        isExternal = true;
        confirmValue = valueExternal;
      } else {
        confirmValue = checkAndExtractValue(selectedValue, true);
        confirmType = 'static_option';
      }
    } else if (fieldType === 'boolean') {
      if (selectedValue.value === 'EXTERNAL') {
        isExternal = true;
        confirmValue = valueExternal;
      } else {
        confirmValue =
          selectedValue.value === 'true'
            ? true
            : selectedValue.value === 'false'
            ? false
            : checkAndExtractValue(selectedValue, false);
        confirmType = 'boolean';
      }
    } else {
      /*
      Commented the code below as it was only setting first value from the List
      Todo: Vijay -> Added !isMulti in the CURRENT_USER IFs to handle only single value please check
      */
      // if (isMulti && selectedValue) {
      //   selectedValue = selectedValue[0]; //? Why setting first value from the List?
      // }
      if (selectedValue) {
        if (
          !isMulti &&
          CURRENTS.includes(selectedValue.value) &&
          [createdBy.id, 'createdby'].includes(fieldType)
        ) {
          confirmValue = selectedValue.value;
        } else if (!isMulti && selectedValue.value === CURRENT_USER) {
          if (!selectedCurrentUserRef || !selectedCurrentUserRef.value) {
            return { selectedCurrentUserRefError: 'Please select Field', status: 'ERROR' };
          }
          if (
            !isFieldIsCollectionRefField(projectCollections, 'user', selectedCurrentUserRef.value)
          ) {
            confirmValue = `${CURRENT_USER}::${selectedCurrentUserRef.value}`;
          } else {
            if (!selectedCurrentUserRefField || !selectedCurrentUserRefField.value) {
              return { selectedCurrentUserRefFieldError: 'Please select Field', status: 'ERROR' };
            }
            confirmValue = `${CURRENT_USER}::${selectedCurrentUserRef.value}::${selectedCurrentUserRefField.value}`;
          }
        } else if (!isMulti && selectedValue.value === CURRENT_TENANT) {
          if (!selectedCurrentUserRef || !selectedCurrentUserRef.value) {
            return { selectedCurrentUserRefError: 'Please select Field', status: 'ERROR' };
          }
          //TODO:try to refactor and remove if else
          if (
            !isFieldIsCollectionRefField(
              projectCollections,
              multiTenantCollection,
              selectedCurrentUserRef.value,
            )
          ) {
            confirmValue = `${CURRENT_TENANT}::${selectedCurrentUserRef.value}`;
          } else {
            if (!selectedCurrentUserRefField || !selectedCurrentUserRefField.value) {
              return { selectedCurrentUserRefFieldError: 'Please select Field', status: 'ERROR' };
            }
            confirmValue = `${CURRENT_TENANT}::${selectedCurrentUserRef.value}::${selectedCurrentUserRefField.value}`;
          }
        } else if (!isMulti && selectedValue.value === CURRENT_SETTINGS) {
          if (!selectedCurrentUserRef || !selectedCurrentUserRef.value) {
            return { selectedCurrentUserRefError: 'Please select Field', status: 'ERROR' };
          }
          if (
            !isFieldIsCollectionRefField(
              projectCollections,
              userSettingsCollection,
              selectedCurrentUserRef.value,
            )
          ) {
            confirmValue = `${CURRENT_SETTINGS}::${selectedCurrentUserRef.value}`;
          } else {
            if (!selectedCurrentUserRefField || !selectedCurrentUserRefField.value) {
              return { selectedCurrentUserRefFieldError: 'Please select Field', status: 'ERROR' };
            }
            confirmValue = `${CURRENT_SETTINGS}::${selectedCurrentUserRef.value}::${selectedCurrentUserRefField.value}`;
          }
        } else if (!isMulti && selectedValue.value === CURRENT_SUB_TENANT) {
          if (!selectedCurrentUserRef || !selectedCurrentUserRef.value) {
            return { selectedCurrentUserRefError: 'Please select Field', status: 'ERROR' };
          }
          if (
            !isFieldIsCollectionRefField(
              projectCollections,
              subTenantCollection,
              selectedCurrentUserRef.value,
            )
          ) {
            confirmValue = `${CURRENT_SUB_TENANT}::${selectedCurrentUserRef.value}`;
          } else {
            if (!selectedCurrentUserRefField || !selectedCurrentUserRefField.value) {
              return { selectedCurrentUserRefFieldError: 'Please select Field', status: 'ERROR' };
            }
            confirmValue = `${CURRENT_SUB_TENANT}::${selectedCurrentUserRef.value}::${selectedCurrentUserRefField.value}`;
          }
        } else if (!isMulti && selectedValue.value === 'EXTERNAL') {
          isExternal = true;
          confirmValue = valueExternal;
        } else if (!isMulti && selectedValue.value === 'FIXED_VALUE') {
          confirmValue = `FIXED_VALUE::${valueFixedValue}`;
          confirmType = fieldType
            ? fieldType
            : selectedField && selectedField.type
            ? selectedField.type
            : '';
        } else if (!isMulti && selectedValue.value === 'ENTITY') {
          if (!entityItemPath && !entityItemPath.value)
            return {
              entityItemPathError: 'Please define the path of entity item',
              status: 'ERROR',
            };
          confirmValue = `ENTITY::${entityItemPath.value}`;
        } else if (['date', 'datentime'].includes(fieldType)) {
          confirmValue = DateTimeUnit.includes(selectedValue.value)
            ? `${dateConstantType.value}:${dateUnitNum}:${selectedValue.value}`
            : selectedValue.value;
          confirmType = '';
        } else {
          confirmValue = checkAndExtractValue(selectedValue, false);
          confirmType = '';
        }
      } else if (
        selectedValueMax &&
        selectedValueMax.value &&
        selectedValueMin &&
        selectedValueMin.value
      ) {
        if (selectedValueMax.value === 'EXTERNAL' || selectedValueMin.value === 'EXTERNAL') {
          isExternal = true;
          confirmValue = `${minExternal}---${maxExternal}`;
        } else if (
          selectedValueMax.value === 'FIXED_VALUE' ||
          selectedValueMin.value === 'FIXED_VALUE'
        ) {
          confirmValue = `FIXED_VALUE::${minFixedValue}---${maxFixedValue}^`;
          confirmType = fieldType
            ? fieldType
            : selectedField && selectedField.type
            ? selectedField.type
            : '';
        } else if (defaultFields2.includes(fieldType)) {
          const minValue = DateTimeUnit.includes(selectedValueMin.value)
            ? `${minDateConstantType.value}:${minDateUnitNum}:${selectedValueMin.value}`
            : selectedValueMin.value;
          const maxValue = DateTimeUnit.includes(selectedValueMax.value)
            ? `${maxDateConstantType.value}:${maxDateUnitNum}:${selectedValueMax.value}`
            : selectedValueMax.value;
          confirmValue = `${minValue}---${maxValue}`;
        } else {
          confirmType = fieldType;
          confirmValue = `${selectedValueMin.value}---${selectedValueMax.value}`;
        }
      } else {
        return { selectedValueError: 'Please select value to be used', status: 'ERROR' };
      }
    }
  } else {
    confirmType = fieldType;
  }

  if ([confirmType, fieldType].includes(date.id))
    confirmType = getDateDisplayType(fields, selectedField.value);
  return {
    conjunctionType: `${condition.id > 1 ? (conjuctionType.value === 'OR' ? 'OR' : 'AND') : ''}`,
    requiredExternal: isExternal,
    query: {
      field: selectedField.value,
      key: selectedCondition.value,
      value: confirmValue,
      fieldType: confirmType === 'belongsto' ? 'belongsTo' : confirmType || fieldType,
      refCollection,
      refField,
      isFilter,
      customEntityKey: customEntityKey ? customEntityKey.value : '',
    },
    status: 'SUCCESS',
  };
};

export const showSaveButtonUtil = (props, state) => {
  const { condition } = props;
  const {
    selectedField,
    selectedCondition,
    selectedValue,
    selectedValueMin,
    selectedValueMax,
    conjuctionType,
    selectedValueCollectionFieldValue,
    selectedValueCollection,
    selectedValueCollectionField,
    selectedValueCollectionFilterValue,
    choiceOfFieldSelect,
    minExternal,
    maxExternal,
    valueExternal,
    collectionFieldValueExternal,
    selectedCurrentUserRef,
    selectedCurrentUserRefField,
  } = state;
  let showButton = false;
  if (
    selectedCondition &&
    selectedCondition.value &&
    condition.query.key !== selectedCondition.value
  ) {
    return true;
  }

  if (!selectedField || condition.query.field !== selectedField.value) {
    return true;
  }

  if (condition.conjunctionType && condition.conjunctionType !== conjuctionType.value) {
    return true;
  }

  const { fieldType, value, refCollection, refField, isFilter } = condition.query;
  if (condition.requiredExternal) {
    // first condition matched selected value is undefined so return true
    if (selectedValue.value === 'EXTERNAL') {
      return valueExternal != value;
    } else if (selectedValueCollectionFieldValue.value === 'EXTERNAL') {
      return collectionFieldValueExternal != value;
    } else if (selectedValueMin.value === 'EXTERNAL' && selectedValueMax.value === 'EXTERNAL') {
      return `${minExternal}---${maxExternal}` != value;
    } else {
      return true;
    }
  }

  if (fieldType === 'dynamic_option') {
    showButton = !checkAndCompareValue(value, selectedValueCollectionFieldValue);
  } else if (fieldType === 'reference') {
    if (isFilter && (!choiceOfFieldSelect || choiceOfFieldSelect.value === 'CHOOSE_FIELD')) {
      return true;
    }

    if (!choiceOfFieldSelect || choiceOfFieldSelect.value === 'CHOOSE_FIELD') {
      if (
        selectedValueCollection.value !== refCollection &&
        selectedValueCollection.value !== CURRENT_USER
      ) {
        showButton = true;
      } else if (
        selectedValueCollectionField.value !== refField &&
        selectedValueCollection.value !== CURRENT_USER
      ) {
        showButton = true;
      } else {
        if (
          selectedValueCollectionFieldValue.value !== 'EXTERNAL' &&
          selectedValueCollection.value !== CURRENT_USER
        ) {
          showButton = !checkAndCompareValue(value, selectedValueCollectionFieldValue);
        } else if (selectedValueCollection.value === CURRENT_USER) {
          showButton = false;
        } else {
          showButton = selectedValueCollectionFieldValue.value != value;
        }
      }
    } else {
      if (selectedValueCollectionFilterValue.value !== value) {
        showButton = true;
      }
    }
  } else if (fieldType === 'between') {
    if (value !== `${selectedValueMin.value}---${selectedValueMax.value}`) {
      showButton = true;
    }
  } else {
    if (selectedValue && selectedValue.value === CURRENT_USER) {
      showButton =
        value !==
        `${CURRENT_USER}::${selectedCurrentUserRef.value}::${selectedCurrentUserRefField.value}`;
    } else {
      showButton = !checkAndCompareValue(value, selectedValue);
    }
  }
  if (showButton && (condition.query.key === IS_NULL || condition.query.key === IS_NOT_NULL)) {
    showButton = false;
  }
  return showButton;
};

const findFilterName = (collections, query) => {
  const queryCollection = collections
    ? collections.find((coll) => coll.collectionName === query.refCollection)
    : null;
  if (queryCollection) {
    const queryCollectionFilter = queryCollection.finders.find(
      (filter) => filter.uuid === query.value,
    );
    return queryCollectionFilter ? queryCollectionFilter.name : '';
  }
};

export const collectionRefFields = (collections, collectionName, isStaticFieldAllowed = false) => {
  if (collections.length === 0) return null;
  const collection = collections.find((collection) =>
    [collection.collectionName.toLowerCase(), collection.uuid].includes(collectionName),
  );
  if (!collection) return null;

  const { fields } = collection;
  let allowedFields = [...referenceTextField];
  if (isStaticFieldAllowed) allowedFields.push(FieldTypes.static_option.id);
  const options = fields.filter((field) => allowedFields.includes(field.type));
  return options.map((option) => {
    return { label: option.fieldTitle.en, value: option.fieldName };
  });
};

export const isFieldIsCollectionRefField = (collections, collectionName, selectedFieldName) => {
  if (collections.length === 0) {
    return null;
  }

  const userCollection = collections.find((collection) =>
    [collection.collectionName.toLowerCase(), collection.uuid].includes(collectionName),
  );

  const { fields } = userCollection;
  const selectedField = fields.find((e) => e.fieldName === selectedFieldName);
  return selectedField && selectedField.type === 'reference' ? true : false;
};

export const collectionRefFieldOption = (collections, collectionName, selectedCondition) => {
  if (collections.length === 0) return null;

  const collection = collections.find((e) =>
    [e.collectionName.toLowerCase(), e.uuid].includes(collectionName),
  );
  const selectedField = collection.fields.find((e) => e.fieldName === selectedCondition);
  const refCollection = collections.find(
    (e) => e.collectionName === selectedField.refCollection.collectionName,
  );
  const { fields } = refCollection;
  const options = fields.filter((field) =>
    [uuid.id, ...textNumberField, color.id].includes(field.type),
  );

  return options.map((option) => {
    return { label: option.fieldTitle.en, value: option.fieldName };
  });
};

export const dateConstantTypes = [
  { label: 'Ago', value: 'SUB' },
  { label: 'Later', value: 'ADD' },
];

const extractDerivedFieldFromMetaData = (derivedFieldStr) => {
  let field = derivedFieldStr.replace('DF::', '');
  field = field.replaceAll('*#*#', '"');
  const derivedField = JSON.parse(field);
  return derivedField;
};

export const getInitialValues = (filter) => {
  return {
    name: filter.name || '',
    isPrivate: filter.isPrivate || false,
    selectSortField: {
      label: filter.sortBy === 'createdAt' ? 'Created At' : filter.sortBy,
      value: filter.sortBy || 'createdAt',
    },
    selectOrderBy: {
      label: filter.orderBy === 'asc' ? 'Ascending' : 'Descending',
      value: filter.orderBy || 'asc',
    },
  };
};
export const getValidationSchema = () => {
  return Yup.object().shape({
    name: Yup.string().required('Filter name is required'),
    isPrivate: Yup.bool(),
    selectSortField: Yup.object().shape({
      label: Yup.string().required('Sort field is required'),
      value: Yup.string().required('Sort field value is required'),
    }),
    selectOrderBy: Yup.object().shape({
      label: Yup.string().required('Order is required'),
      value: Yup.string().required('Order value is required'),
    }),
  });
};

export const orderByOption = [
  { label: 'Ascending', value: 'asc' },
  { label: 'Descending', value: 'desc' },
];

export const processRlsFilterQueryData = (values, conditionData) => {
  let { name, isPrivate } = values;
  const { conditions } = conditionData;

  const queryData = {
    rowLevelSecurityFilter: {
      isPrivate,
      name,
      conditions,
    },
  };

  return queryData;
};

export const showRlsFilterQueryString = ({ conditions }, collections) => {
  let queryString = '';

  if (conditions.length > 0) {
    queryString += ' where ';
    conditions.forEach((condition) => {
      const { conjunctionType, query } = condition;
      if (conjunctionType) queryString += `${conjunctionType} `;
      if (query.field) queryString += `${query.field} `;
      if (query.key) queryString += `${snakeCaseToTitleCase(query.key)} `;
      if (query.isFilter) {
        if (query.value) queryString += `${findFilterName(collections, query)} `;
      } else {
        if (query.value) queryString += `${query.value} `;
        if (query.value === false) queryString += 'false';
      }
    });
  }

  return queryString;
};

const getDateDisplayType = (fields, selectedField) => {
  const field = fields.find((field) => field.fieldName === selectedField);
  if (!field || !field.extraFieldSetting) return 'datetime-local';
  const { extraFieldSetting } = field;
  return extraFieldSetting.dateDisplayType || 'datetime-local';
};
